var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner actual-payment-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Clearing.SelectActualReceiptAndPayment"),
        width: "960px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("search-item", {
        ref: "searchItem",
        attrs: {
          "show-more-scheme": true,
          "show-simple": true,
          "expand-adv": true,
          "sim-url": "",
          "adv-url": "",
          "search-item-code": _vm.$t("Clearing.Invoice"),
          "search-item-mode": "querydata",
          "config-module": "800"
        }
      }),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { "min-height": "300px" }
        },
        [
          _vm.innerVisible
            ? _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "180601",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-pagination-right",
          staticStyle: { padding: "0 10px" }
        },
        [
          _c("cargo-pagination", {
            attrs: {
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchData
            }
          }),
          _c("div", { staticClass: "total-detail-popover" }, [
            _c("span", [_c("b", [_vm._v("USD:")])]),
            _c("span", [_c("u", [_vm._v("666666")])]),
            _c("span", [_c("b", [_vm._v("RMB:")])]),
            _c("span", [_c("u", [_vm._v("666666")])]),
            _c("span", [
              _c("b", [_vm._v(_vm._s(_vm.$t("Clearing.EquivalentToRMB")))])
            ]),
            _c("span", [_c("u", [_vm._v("666666")])])
          ])
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary", no: "1" }, on: { click: _vm.confirm } },
            [_vm._v("确认")]
          ),
          _c("el-button", { attrs: { no: "2" }, on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$t("Clearing.Cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }